import { render, staticRenderFns } from "./SendGroupEnrollment.vue?vue&type=template&id=2c2b785e&scoped=true&"
import script from "./SendGroupEnrollment.vue?vue&type=script&lang=js&"
export * from "./SendGroupEnrollment.vue?vue&type=script&lang=js&"
import style0 from "./SendGroupEnrollment.vue?vue&type=style&index=0&id=2c2b785e&scoped=true&lang=css&"
import style1 from "./SendGroupEnrollment.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2b785e",
  null
  
)

export default component.exports